<template>
  <swiper
    ref="mainPromoSwiper"
    class="main-promo-slider"
    :options="swiperMainPromoOptions"
  >
    <swiper-slide
      v-for="(card, idxCard) in achievementsList"
      :key="idxCard"
      class="main-promo-slider__card"
    >
      <a :href="card.href" target="_blank">
        <div class="main-promo-slider__card_title">{{ card.title }}</div>
        <div class="main-promo-slider__card_text">{{ card.text }}</div>
      </a>
    </swiper-slide>
    <div class="main-promo-slider__pagination"></div>
  </swiper>
</template>
<script>
import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.min.css'

Vue.use(VueAwesomeSwiper)

export default {
  data() {
    return {
      swiperMainPromoOptions: {
        slidesPerView: 1,
        pagination: {
          el: '.main-promo-slider__pagination',
          bulletClass: 'main-promo-slider__pagination-item',
          bulletActiveClass: '--active',
          clickable: true, // Пагинацию можно кликать
          dynamicBullets: true,
        },
        effect: 'fade', // Затухание
        fadeEffect: {
          crossFade: true, // Плавный переход
        },
        loop: true,
        speed: 300,
        autoplay: true,
      },
      achievementsList: [
        {
          title: '№1 в рейтинге облачных платформ',
          text: 'J`son & Partners Consulting',
          href: '/blog/mts-link-stal-liderom-sredi-vks-servisov/',
        },
        {
          title: 'Лидер рынка ВКС по интеграции ИИ',
          text: 'TelecomDaily',
          href: '/blog/mts-link-v-trojke-liderov-rynka-vks-po-integracii-ii/',
        },
        {
          title: 'Лучшая техподдержка в отрасли',
          text: 'IT-World',
          href: '/blog/mts-link-priznan-luchshim-v-rossii-vks-servisom-po-kachestvu-tekhpodderzhki/',
        },
      ],
    }
  },
  computed: {
    swiper() {
      return this.$refs.mainPromoSwiper.$swiper
    },
  },
}
</script>
<style lang="scss" scoped>
.main-promo-slider {
  ::v-deep {
    .swiper-slide {
      height: auto;
    }
  }
  &__card {
    background: #fff8f1a6;
    border: 1px solid #ffffff4d;
    backdrop-filter: blur(16px);
    border-radius: 20px;
    @include screen-down('md') {
      text-align: center;
    }
    &_title {
      font-family: $font-mts-wide;
      font-weight: 700;
      font-size: 10px;
      line-height: 12px;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      margin-bottom: 4px;
    }
    &_text {
      font-size: 12px;
      line-height: 16px;
    }
    a {
      display: block;
      padding: 16px;
      text-decoration: none;
      color: inherit;
    }
  }
  &__pagination {
    position: absolute;
    width: auto !important;
    left: 50%;
    bottom: -14px;
    transform: translatex(-50%);
    overflow: visible;
    z-index: 1;
    &-item {
      :deep & {
        border-radius: 0;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        opacity: 1;
        background: #c3bcb5;
        display: inline-block;
        cursor: pointer;
        transition: all 0.5s;
        &:not(:last-child) {
          margin-right: 4px;
        }
        &.--active {
          background: #fff8f1;
          width: 12px;
          border-radius: 10px;
        }
      }
    }
  }
}
</style>
